import { Instance, types } from 'mobx-state-tree';

export const StudentResult = types
  .model('StudentResultModel', {
    batchSubjectExtraSlotName: types.maybe(types.string),
    batchSubjectExtraSlotId: types.maybe(types.string),
    assessmentTitle: types.maybe(types.string),
    assessmentId: types.maybe(types.string),
    allocatedMarks: types.maybeNull(types.number),
    firstAttemptMarks: types.maybeNull(types.number),
    isFirstAttemptNYC: types.maybe(types.boolean),
    secondAttemptMarks: types.maybeNull(types.number),
    isSecondAttemptNYC: types.maybe(types.boolean),
    thirdAttemptMarks: types.maybe(types.number),
    isThirdAttemptNYC: types.maybeNull(types.boolean),
  })
  .actions((self) => ({
    updateFirstAttemptMarks(firstAttemptMarks: number) {
      self.firstAttemptMarks = firstAttemptMarks;
    },
    updateSecondAttemptMarks(secondAttemptMarks: number) {
      self.secondAttemptMarks = secondAttemptMarks;
    },
    updateThirdAttemptMarks(thirdAttemptMarks: number) {
      self.thirdAttemptMarks = thirdAttemptMarks;
    },
    updateFirstAttemptNYC(firstAttemptNYC: boolean) {
      self.isFirstAttemptNYC = firstAttemptNYC;
    },
    updateSecondAttemptNYC(secondAttemptNYC: boolean) {
      self.isSecondAttemptNYC = secondAttemptNYC;
    },
    updateThirdAttemptNYC(thirdAttemptNYC: boolean) {
      self.isThirdAttemptNYC = thirdAttemptNYC;
    },
  }));

export type StudentResultModelType = Instance<typeof StudentResult>;
